import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { TokenModel } from '../../models/token.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigProvider } from '../base/config';
import { Util } from '../base/util';

const OauthLoginEndPointUrl: any =
  ConfigProvider.host + '/api/v1/front/core/auth/token';

@Injectable()
export class AuthProvider {
  private loginSubject$ = new BehaviorSubject<boolean>(false);

  loginChanged$ = this.loginSubject$.asObservable();

  constructor(public http: HttpClient) {}

  cachedRequests: Array<HttpRequest<any>> = [];

  public collectFailedRequest(request): void {
    this.cachedRequests.push(request);
  }

  getAccessToken(user): Observable<TokenModel> {
    user.client_id = ConfigProvider.client_id;
    user.client_secret = ConfigProvider.token;
    user.grant_type = ConfigProvider.grant_type;
    return this.http.post(OauthLoginEndPointUrl, user).pipe(
      map((response: any) => {
        let res = new TokenModel().deserialize(response);
        AuthProvider.setToken(res);
        this.auth(true);
        return res;
      })
    );
  }

  public retryFailedRequests(): void {}

  auth(isAuth: boolean) {
    this.loginSubject$.next(isAuth);
  }

  static getUser() {
    let usuario = JSON.parse(window.localStorage.getItem('usuario'));
    if (usuario == null) {
      return null;
    }
    return usuario;
  }

  static setUser(user) {
    window.localStorage.setItem('usuario', JSON.stringify(user));
  }

  static getToken() {
    let token = window.localStorage.getItem('token');
    if (token == null) {
      return null;
    }
    return JSON.parse(token);
  }

  static setToken(token) {
    window.localStorage.setItem('token', JSON.stringify(token));
  }

  static getAccessTokenString() {
    return AuthProvider.getToken().access_token;
  }

  static getContextUser() {
    return AuthProvider.getToken().context_user;
  }

  static getUserId() {
    return AuthProvider.getUser().data.id;
  }

  static autenticado() {
    return !!AuthProvider.getToken();
  }

  static deslogar() {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('usuario');
  }

  static setFCMToken(token) {
    if (Util.isNullOrUndefined(token)) return;
    window.localStorage.setItem('fcm_token', JSON.stringify(token));
  }

  static getFCMToken() {
    if (Util.isNullOrUndefined(window.localStorage.getItem('fcm_token')))
      return null;
    return window.localStorage
      .getItem('fcm_token')
      .replace('"', '')
      .replace('"', '');
  }

  static setDeviceUUID(uuid) {
    window.localStorage.setItem('device_uuid', JSON.stringify(uuid));
  }

  static getDeviceUUID() {
    if (Util.isNullOrUndefined(window.localStorage.getItem('device_uuid')))
      return null;
    return window.localStorage
      .getItem('device_uuid')
      .replace('"', '')
      .replace('"', '');
  }

  static contemUUID() {
    return !!AuthProvider.getDeviceUUID();
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts